import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';
import { FormContext } from './FormCRUD';
import FormField from 'mrf/view/FormField';
import InputFlex from 'mrf/layout/InputFlex';
import Checkbox from 'mrf/styles/basic/Checkbox';
import {useFormFullSelector} from 'mrf/redux/ReduxHelper';
import IF from './IF';

CheckboxField.propTypes = {
    context: PropTypes.object,
    label: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired, // Field name in database.
    initial: PropTypes.bool,
}

export default function CheckboxField({
    context,
    label,
    field,
    actions,
    disabled,
    align = 'center',
    height = 'full',
    justify = 'start',
    initial = false,
    ...props
}) {
    const formContext = useContext(FormContext);
    if (!context) {
        context = formContext;
    }

    const { data, set } = useFormFullSelector(context, field);

    useEffect(() => {
        if (!context.exactErrorKeys && (data === undefined || data === null)) {
            set({ [field]: initial });
        }
    }, [data]); //eslint-disable-line

    return (
        <InputFlex
            as='label'
            align={align}
            justify={justify}
            height={height}
            gap={2}
            {...props}
        >
            <FormField
                type='checkbox'
                field={field}
                name={field}
                span={label}
                checked={data ?? initial}
                component={Checkbox}
                context={context}
                eventMapper={(e) => e.target.checked}
                disabled={disabled || context?.readOnly}
                className="flex gap-2 items-center"
                {...props}
                
            />
            <IF condition={!!actions}>{actions}</IF>
        </InputFlex>
    );
}
